export enum DeviceOrientation {
    PORTRAIT = 'portrait',
    LANDSCAPE = 'landscape',
}

export enum DeviceType {
    MOBILE = 'MOBILE',
    TABLET = 'TABLET',
    DESKTOP = 'DESKTOP',
    APPCHARGE = 'APPCHARGE',
}